// extracted by mini-css-extract-plugin
export var avatarContainer = "_60-1";
export var largeAvatarContainer = "_60-2";
export var smallAvatarContainer = "_60-0";